import { useParams } from 'react-router-dom'
import UserEmailForm from './UserEmailForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'

const UserEmail = () => {

    const { id } = useParams()

    // edit this user
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[id]
        }),
    })    

    if (!user) return <PulseLoader color={"#5f788a"} />

    const content = <UserEmailForm user={user}  />

    return content
}
export default UserEmail